var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"firstpage"},[_c('div',{staticClass:"main-contain"},[_c('div',{staticClass:"elcarousel"},[_c('Carousel')],1),_c('div',{staticClass:"virtualsimulation-experiment"},[_c('Virtualsimulationexperiment')],1),_c('div',{staticClass:"links"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }